__turbopack_context__.v({
  "content": "NavMenu-module-scss-module__Dlo39W__content",
  "icon": "NavMenu-module-scss-module__Dlo39W__icon",
  "item": "NavMenu-module-scss-module__Dlo39W__item",
  "list": "NavMenu-module-scss-module__Dlo39W__list",
  "nav-menu-in": "NavMenu-module-scss-module__Dlo39W__nav-menu-in",
  "trigger": "NavMenu-module-scss-module__Dlo39W__trigger",
});
